const getPersonalData = async (to, from, next) => {
	if (from.path !== '/') {
		const store = App.store.getStoreContext();
		await store.dispatch('personalCabinet/loadPageData', to.path);
	}
	next();
}

export default [
	{
		path: '/:language?/personal',
		component: require('../components/cabinet/Personal/personal').default,
		beforeEnter: getPersonalData,
	},
	{
		path: '/:language?/personal/history',
		component: require('../components/cabinet/cabinet-history.vue').default,
		beforeEnter: getPersonalData,
	},
	{
		path: '/:language?/personal/wishlist',
		component: require('../components/cabinet/favorites-vue.vue').default,
		beforeEnter: getPersonalData,
	},
]